
class ProductAttributeConfigDetailCell extends UITableViewCell
{
    private imageView:MUIImageView = null;
    private nameLabel:MUILabel = null;  
    private attributeLabel:MUILabel = null;

    awakeFromHTML(){
        this.imageView = MUIOutlet(this, "imgage-view", "MUIImageView");
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.attributeLabel = MUIOutlet(this, "attribute-lbl", "MUILabel");
    }
    
    private _productAttribute:ProductAttribute = null;
    set item (item:ProductAttribute){
        if (item == null) return;

        this._productAttribute = item;
        this.nameLabel.text = item.name;
        // this.attributeLabel.text = item.productAttributes.

    }
    
}